<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/pegawai-list-custom">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Daftar DP3</li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Penilaian Pelaksanaan Pekerjaan (DP3)</h5>
    </div>
    <LogPopupTemplate ref="logPopup" />
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxPopupAsPopup
          :visible="loadingVisible"
          :title="loadingTitle"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="300"
          :height="130"
        >
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border"
              style="width: 3rem; height: 3rem"
              role="status"
            ></div>
          </div>
        </DxPopupAsPopup>

        <DxDataGrid
          ref="dataGrid"
          :data-source="dp3ListStore.dataSourceDp3List"
          :remote-operations="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          :focused-row-enabled="true"
          :filter-sync-enabled="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          :height="gridHeight"
          :word-wrap-enabled="true"
          @exporting="onExporting"
          @row-inserting="onInserting"
          @row-validating="onRowValidating"
          @saved="onSaved"
          @editing-start="onEditingStart"
          @init-new-row="onInitNewRow"
          @row-updating="onUpdating"
          @context-menu-preparing="onContextMenuPreparing($event)"
        >
          <DxSorting mode="multiple" />

          <DxHeaderFilter :visible="true" />
          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxEditing
            :allow-updating="allowUpdating"
            :allow-deleting="allowDeleting"
            :allow-adding="allowAdding"
            mode="popup"
          >
            <DxPopup
              :show-title="true"
              title="Data DP3"
              :on-content-ready="handlePopupContentReady"
            />
            <!-- :width="700"
            :height="525" -->
            <DxForm
              :form-data="formData"
              ref="formInstance"
              :customize-item="customizeFormItem"
            >
              <DxItem :col-count="3" :col-span="2" item-type="group">
                <DxItem data-field="tgl_awal" />
                <DxItem data-field="tgl_akhir" />
                <!-- :editor-options="{
                    onValueChanged: onTglValueChanged,
                  }" -->

                <DxItem data-field="tgl_dibuat" />
              </DxItem>

              <DxItem :col-span="2">
                <span><strong>1. Yang Dinilai</strong></span>
              </DxItem>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem data-field="pegawais_nama" editor-type="dxSelectBox" />

                <!-- <DxItem data-field="pegawais_nama" /> -->

                <DxItem
                  data-field="pegawais_nik"
                  editor-type="dxTextBox"
                  :label="{ text: 'NIK', location: 'top' }"
                  :editor-options="{ placeholder: 'NIK', readOnly: true }"
                />
                <DxItem
                  data-field="pegawais_gol"
                  editor-type="dxTextBox"
                  :label="{ text: 'Gol.', location: 'top' }"
                  :editor-options="{ placeholder: 'Gol.', readOnly: true }"
                />
                <DxItem
                  data-field="pegawais_jabatan"
                  editor-type="dxTextBox"
                  :label="{ text: 'Jabatan', location: 'top' }"
                  :editor-options="{ placeholder: 'Jabatan', readOnly: true }"
                />
              </DxItem>

              <DxItem :col-span="2">
                <span><strong>2. Pejabat Penilai</strong></span>
              </DxItem>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem
                  data-field="penilais_nama"
                  editor-type="dxTextBox"
                  :label="{ text: 'Penilai', location: 'top' }"
                  :editor-options="{ placeholder: 'Penilai', readOnly: true }"
                />
                <DxItem
                  data-field="penilais_nik"
                  editor-type="dxTextBox"
                  :label="{ text: 'NIK', location: 'top' }"
                  :editor-options="{ placeholder: 'NIK', readOnly: true }"
                />
                <DxItem
                  data-field="penilais_gol"
                  editor-type="dxTextBox"
                  :label="{ text: 'Gol.', location: 'top' }"
                  :editor-options="{ placeholder: 'Gol.', readOnly: true }"
                />
                <DxItem
                  data-field="penilais_jabatan"
                  editor-type="dxTextBox"
                  :label="{ text: 'Jabatan', location: 'top' }"
                  :editor-options="{ placeholder: 'Jabatan', readOnly: true }"
                />
              </DxItem>

              <DxItem :col-span="2">
                <span><strong>3. Atasan Pejabat Penilai</strong></span>
              </DxItem>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem
                  data-field="atasan_penilais_nama"
                  editor-type="dxTextBox"
                  :label="{ text: 'Jabatan', location: 'top' }"
                  :editor-options="{ placeholder: 'Jabatan', readOnly: true }"
                />
                <DxItem
                  data-field="atasan_penilais_nik"
                  editor-type="dxTextBox"
                  :label="{ text: 'NIK', location: 'top' }"
                  :editor-options="{ placeholder: 'NIK', readOnly: true }"
                />
                <DxItem
                  data-field="atasan_penilais_gol"
                  editor-type="dxTextBox"
                  :label="{ text: 'Gol.', location: 'top' }"
                  :editor-options="{ placeholder: 'Gol.', readOnly: true }"
                />
                <DxItem
                  data-field="atasan_penilais_jabatan"
                  editor-type="dxTextBox"
                  :label="{ text: 'Jabatan', location: 'top' }"
                  :editor-options="{ placeholder: 'Jabatan', readOnly: true }"
                />
              </DxItem>

              <DxItem :col-span="2">
                <span><strong>4. Penilaian</strong></span>
                <DxDataGrid
                  ref="dataGridPeserta"
                  :data-source="penilaianDataSource"
                  :focused-row-index="0"
                  :show-borders="true"
                  :show-column-lines="false"
                  :focused-row-enabled="true"
                  :column-auto-width="true"
                  :column-hiding-enabled="false"
                  :allow-column-reordering="true"
                  key-expr="id"
                  @saved="onPenilaianSaved"
                >
                  <dx-paging :page-size="10" />
                  <dx-pager :show-page-size-selector="true" :show-info="true" />
                  <dx-filter-row :visible="true" />
                  <DxExport
                    :enabled="true"
                    :allow-export-selected-data="true"
                  />
                  <DxEditing
                    :allow-updating="true"
                    :allow-deleting="false"
                    :allow-adding="false"
                    mode="batch"
                  />
                  <DxSorting mode="multiple" />

                  <DxColumn
                    caption="Unsur"
                    data-field="unsur"
                    :allow-updating="false"
                    :allow-editing="false"
                  >
                  </DxColumn>

                  <DxColumn
                    caption="Angka"
                    data-field="angka"
                    data-type="number"
                    :set-cell-value="handleAngkaSetCellValue"
                  ></DxColumn>
                  <DxColumn
                    caption="Sebutan"
                    data-field="sebutan"
                    data-type="string"
                    :allow-updating="false"
                    :allow-editing="false"
                  ></DxColumn>

                  <DxColumn
                    caption="Ket."
                    data-field="ket"
                    data-type="string"
                  ></DxColumn>

                  <DxSummary>
                    <DxTotalItem
                      column="angka"
                      summary-type="sum"
                      value-format="#,##0"
                      display-format="Jumlah: {0}"
                    />
                    <DxTotalItem
                      column="angka"
                      summary-type="avg"
                      value-format="#,##0.00"
                      display-format="Rata-rata: {0}"
                    />
                  </DxSummary>
                </DxDataGrid>
              </DxItem>

              <DxItem :col-span="2">
                <span
                  ><strong
                    >5. Keberatan dari pegawai yang dinilai (apabila
                    ada)</strong
                  ></span
                >
              </DxItem>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem data-field="keberatan_pegawai" />
                <DxItem data-field="keberatan_pegawai_tgl" />
              </DxItem>

              <DxItem :col-span="2">
                <span
                  ><strong
                    >6. Tanggapan pejabat penilai atas keberatan</strong
                  ></span
                >
              </DxItem>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem data-field="tanggapan_penilai" />
                <DxItem data-field="tanggapan_penilai_tgl" />
              </DxItem>
              <DxItem :col-span="2">
                <span
                  ><strong
                    >7. Keputusan/rekomendasi atasan pejabat penilai</strong
                  ></span
                >
              </DxItem>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem data-field="keputusan_atasan" />
                <DxItem data-field="keputusan_atasan_tgl" />
              </DxItem>
              <DxItem :col-count="2" :col-span="2" item-type="group">
                <DxItem data-field="file_path" />
              </DxItem>
              <DxItem data-field="dummy" css-class="hidden-field" />
            </DxForm>
          </DxEditing>
          <DxPaging :page-size="15" />
          <DxPager :visible="true" />
          <DxExport :enabled="true" />
          <DxToolbar>
            <DxItem location="after">
              <DxButton
                icon="refresh"
                @click="refreshDatagrid('dataGrid')"
                text="Refresh Data"
                type="default"
                style="float: left"
                width="160px"
                styling-mode="outlined"
              ></DxButton>
            </DxItem>
            <DxItem name="groupPanel" />
            <DxItem
              name="addRowButton"
              show-text="always"
              v-if="can('pegawai-create')"
            />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
          </DxToolbar>
          <template #refresh-template> </template>

          <DxColumn
            class="noteditable"
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            data-type="number"
            :fixed="true"
            fixed-position="left"
          />

          <DxColumn
            :allowHeaderFiltering="false"
            data-field="pegawais_nik"
            caption="NIK"
            data-type="string"
            :fixed="true"
            fixed-position="left"
          />

          <DxColumn
            data-field="pegawai_id"
            caption="PegawaiId"
            :visible="false"
            :fixed="true"
            fixed-position="left"
          />

          <DxColumn
            data-field="penilai_id"
            caption="PenilaiId"
            :visible="false"
            :fixed="true"
            fixed-position="left"
          />

          <DxColumn
            data-field="atasan_penilai_id"
            caption="Atasan PenilaiId"
            :visible="false"
            :fixed="true"
            fixed-position="left"
          />

          <DxColumn
            data-field="pegawais_nama"
            caption="Pegawai"
            :visible="true"
            :allow-filtering="true"
            :allowHeaderFiltering="true"
            :allow-sorting="true"
            :header-filter="{
              dataSource: commonStore.getPegawaiSource(pegawaiSource).value,
            }"
            :fixed="true"
            fixed-position="left"
            :allow-editing="can('pegawai-update')"
            :min-width="200"
            :filterOperations="['contains', 'startswith']"
          />

          <DxColumn
            data-field="penilais_nama"
            caption="Penilai"
            :visible="true"
            :allow-filtering="true"
            :allowHeaderFiltering="true"
            :allow-sorting="true"
            :header-filter="{
              dataSource: commonStore.getPenilaiSource(pegawaiSource).value,
            }"
            :allow-editing="can('pegawai-update')"
            :min-width="200"
            :filterOperations="['contains', 'startswith']"
          />

          <DxColumn
            data-field="atasan_penilais_nama"
            caption="Atasan Penilai"
            :visible="true"
            :allow-filtering="true"
            :allowHeaderFiltering="true"
            :allow-sorting="true"
            :header-filter="{
              dataSource:
                commonStore.getAtasanPenilaiSource(pegawaiSource).value,
            }"
            :allow-editing="can('pegawai-update')"
            :min-width="200"
            :filterOperations="['contains', 'startswith']"
          />

          <DxColumn
            :allowHeaderFiltering="false"
            data-field="tgl_awal"
            caption="Tgl Awal Penilaian"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            :allowHeaderFiltering="false"
            data-field="tgl_akhir"
            caption="Tgl Akhir Penilaian"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            :allowHeaderFiltering="false"
            data-field="tgl_dibuat"
            caption="Tgl Dibuat"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="kesetiaan"
            :allowHeaderFiltering="false"
            caption="Kesetiaan"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="prestasi_kerja"
            :allowHeaderFiltering="false"
            caption="Prestasi Kerja"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="tanggung_jawab"
            :allowHeaderFiltering="false"
            caption="Tanggung Jawab"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="ketaatan"
            :allowHeaderFiltering="false"
            caption="Ketaatan"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="kejujuran"
            :allowHeaderFiltering="false"
            caption="Kejujuran"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="kerjasama"
            :allowHeaderFiltering="false"
            caption="Kerjasama"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="prakarsa"
            :allowHeaderFiltering="false"
            caption="Prakarsa"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="kepemimpinan"
            :allowHeaderFiltering="false"
            caption="Kepemimpinan"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="jumlah"
            :allowHeaderFiltering="false"
            caption="Jumlah"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="avg"
            :allowHeaderFiltering="false"
            caption="Rata-rata"
            data-type="number"
          >
            <!-- <DxRequiredRule /> -->
          </DxColumn>

          <DxColumn
            data-field="keberatan_pegawai"
            :allowHeaderFiltering="false"
            caption="Keberatan Pegawai"
            data-type="string"
          />

          <DxColumn
            data-field="keberatan_pegawai_tgl"
            :allowHeaderFiltering="false"
            caption="Tgl Keberatan Pegawai"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />
          <DxColumn
            data-field="tanggapan_penilai"
            :allowHeaderFiltering="false"
            caption="Tanggapan Penilai"
            data-type="string"
          />

          <DxColumn
            data-field="tanggapan_penilai_tgl"
            :allowHeaderFiltering="false"
            caption="Tgl Tanggapan Penilai"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />

          <DxColumn
            data-field="keputusan_atasan"
            :allowHeaderFiltering="false"
            caption="Keputusan Atasan"
            data-type="string"
          />

          <DxColumn
            data-field="keputusan_atasan_tgl"
            :allowHeaderFiltering="false"
            caption="Tgl Keputusan Atasan"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
          />

          <DxColumn
            data-field="dummy"
            :allowHeaderFiltering="false"
            caption="dummy"
            :visible="false"
          >
          </DxColumn>

          <DxColumn
            :allowHeaderFiltering="false"
            :allow-filtering="false"
            :allow-sorting="true"
            :allow-exporting="false"
            :allow-editing="true"
            :allow-adding="true"
            cell-template="fileTemplate"
            caption="Dokumen"
            data-field="file_path"
            data-type="string"
            edit-cell-template="editFileTemplate"
          >
          </DxColumn>

          <template #fileTemplate="{ data }">
            <div class="small-button-container">
              <DxButton
                :visible="setPrintAdaFile(data.text)"
                @click="
                  commonFunction.handleClickDocument(
                    data,
                    data.data.pegawais_nama + ' - File DP3',
                  )
                "
                icon="download"
              />
            </div>
          </template>

          <template #editFileTemplate="{ data }">
            <div>
              <DxFileUploader
                ref="fileUploaderRef"
                accept="*"
                upload-mode="useForm"
                @value-changed="onFileValueChanged($event, { data })"
                @uploaded="onUploaded($event, { data })"
                @upload-error="onUploadError"
              />
            </div>
          </template>

          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />
          <DxColumn type="buttons" :width="110">
            <DxButtonDataGrid name="edit" />
            <DxButtonDataGrid name="delete" />
            <DxButtonDataGrid
              hint="View Log Perubahan"
              icon="clock"
              :visible="true"
              @click="this.$refs.logPopup.showBySubject($event, 'Dp3')"
            />
          </DxColumn>

          <DxSummary>
            <DxTotalItem
              column="kesetiaan"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="prestasi_kerja"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="tanggung_jawab"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="ketaatan"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="kejujuran"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="kerjasama"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="prakarsa"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="kepemimpinan"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem
              column="jumlah"
              summary-type="sum"
              value-format="#,##0"
            />
            <DxTotalItem column="avg" summary-type="sum" value-format="#,##0" />
          </DxSummary>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.hidden-field {
  display: none !important;
}
</style>
<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import notify from "devextreme/ui/notify";
import auth from "@/auth";
import { ref } from "vue";
import { reactive } from "vue";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import { DateTime } from "luxon";
import * as XLSX from "xlsx";
import * as commonFunction from "@/utils/common-function.js";
import { BASE_URL } from "@/global-constants";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
import { useDiklatListModel } from "@/stores/models/diklat-list-model";
import { useCommonStore } from "@/stores/utility/common-store2";
import can from "@/haspermission";
import _ from "lodash";
import DataSource from "devextreme/data/data_source";
import { DxPopup as DxPopupAsPopup } from "devextreme-vue/popup";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
  DxPopup,
  DxForm,
  DxSorting,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";

import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

import DxButton from "devextreme-vue/button";
import { useDukListStore } from "@/stores/views/duk-list-store";
import { useHirarkiListStore } from "@/stores/views/hirarki-list-store";
import { useDp3ListStore } from "@/stores/views/dp3-list-store";
// import { custom } from "devextreme/ui/dialog";

export default {
  components: {
    LogPopupTemplate,
    DxPopupAsPopup,
    DxForm,
    DxButton,

    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    // DxSelection,
    DxExport,
    DxToolbar,

    DxPopup,

    DxItem,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    DxSorting,
    DxFileUploader,
    DxButtonDataGrid,
  },
  setup() {
    const dp3ListStore = useDp3ListStore();
    const pegawaiListStore = usePegawaiListStore();
    const diklatListModel = useDiklatListModel();
    const dukListStore = useDukListStore();
    const hirarkiListStore = useHirarkiListStore();

    const commonStore = useCommonStore();
    const jmlPeserta = ref(0);
    const resetJmlPeserta = () => {
      jmlPeserta.value = 3;
    };
    const formData = reactive({
      tgl_awal: null,
      tgl_akhir: null,
      tgl_dibuat: null,
      pegawais_nama: null,
      pegawais_id: null,
      pegawai_id: null,
      pegawais_nik: null,
      pegawais_jabatan: null,
      pegawais_gol: null,
      penilais_id: null,
      penilais_nama: null,
      penilais_gol: null,
      penilais_jabatan: null,
      penilais_nik: null,
      atasan_penilais_id: null,
      atasan_penilais_nama: null,
      atasan_penilais_jabatan: null,
      atasan_penilais_gol: null,
      atasan_penilais_nik: null,
    });

    const initialFormData = _.cloneDeep(formData);

    // diklatListStore.dataSourcePeringatanList.filter(null);
    return {
      formData,
      initialFormData,
      dukListStore,
      hirarkiListStore,
      resetJmlPeserta,
      dp3ListStore,
      pegawaiListStore,
      diklatListModel,
      commonStore,
      commonFunction,
    };
  },
  data() {
    return {
      logPopupRef: null,
      penilaianDataSource: new DataSource({
        store: {
          type: "array",
          key: "id",
          data: [
            // Example initial row (optional, can be empty array)
            {
              id: 1,
              unsur: "Kesetiaan",
              field: "kesetiaan",
              angka: null,
              sebutan: null,
              ket: null,
            },
            {
              id: 2,
              unsur: "Prestasi Kerja",
              field: "prestasi_kerja",
              angka: null,
              sebutan: null,
              ket: null,
            },
            {
              id: 3,
              unsur: "Tanggung Jawab",
              field: "tanggung_jawab",
              angka: null,
              sebutan: null,
              ket: null,
            },
            {
              id: 4,
              unsur: "Ketaatan",
              field: "ketaatan",
              angka: null,
              sebutan: null,
              ket: null,
            },
            {
              id: 5,
              unsur: "Kejujuran",
              field: "kejujuran",
              angka: null,
              sebutan: null,
              ket: null,
            },
            {
              id: 6,
              unsur: "Kerjsama",
              field: "kerjasama",
              angka: null,
              sebutan: null,
              ket: null,
            },
            {
              id: 7,
              unsur: "Prakarsa",
              field: "prakarsa",
              angka: null,
              sebutan: null,
              ket: null,
            },
            {
              id: 8,
              unsur: "Kepemimpinan",
              field: "kepemimpinan",
              angka: null,
              sebutan: null,
              ket: null,
            },
          ],
        },
      }),
      selectedPegawaiId: null,
      selectedAtasanPenilaiId: null,
      selectedPenilaiId: null,

      pegawaiBasedOnTglSource: [
        { id: 1, nik: "123", nama: "Budi" },
        { id: 2, nik: "456", nama: "Siti" },
      ],

      // pegawaiBasedOnTglSource: [],
      diklatTglTemp: null,
      allowAddingPegawai: false,
      isEditing: false,
      componentDiklat: null,
      rowIndexDiklat: null,

      dp3datasource: new DataSource({
        store: {
          type: "array",
          key: "key",
          data: [],
        },
      }),

      currentTgl: this.convertTglIndonesia(
        new Date().toISOString().slice(0, 10),
      ),
      pejabatMengetahui: null,
      pejabatMembuat: null,

      serverUrl: `${BASE_URL}/`,

      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,
      filterOperations: ["=", "<>", ">", "<", "between"],
      loadingVisible: false,
      loadingTitle: "Loading data pegawai dan jabatan",
      pegawaiSource: [{ id: null, display_expr: null }],
      formEditors: {},
      file: null,
      fileName: null,
      filePath: null,
      fileUrl: null,
      fileTitle: null,
      fileTableId: null,
      fileTable: null,
      isInserting: false,
      isUpdating: false,
    };
  },

  async created() {
    //
    let filter = null;
    if (!_.isNil(this.$route.query.filter)) {
      filter = this.$route.query.filter;
    }
    this.dp3ListStore.dataSourceDp3List.filter(filter);

    await this.commonStore.preloadStores();
    // const pegawais = await this.pegawaiListStore.getData(null);
    // this.pegawaiSource = pegawais.data;
  },

  async mounted() {
    this.dp3ListStore.initialized;
    let tempA = await this.pegawaiListStore.dataSourcePegawaiListCoba(null, [
      {
        selector: "simpeg_pegawais.nama",
        desc: false,
      },
    ]);

    this.pegawaiSource = tempA.data; //all pegawai

    console.log("debug pegawaiSource", this.pegawaiSource);
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    onPenilaianSaved() {
      // this.formEditors["tgl_akhir"].option("value")
      this.formEditors["dummy"].option("value", "trigger update");
      console.log(
        "onPenilaianSaved",
        this.formEditors["dummy"].option("value"),
      );
    },
    onSaved() {
      if (!this.file) return;
      const formData = new FormData();
      formData.append("fileName", this.fileName);
      formData.append("file", this.file);

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      api
        .post(`/arsip/upload_store`, formData, config)
        .then((response) => {
          notify(response.data.message, response.data.notify_type);
          this.file = null;
          this.fileName = null;
          this.filePath = null;
        })
        .catch((error) => {
          this.file = null;
          this.fileName = null;
          this.filePath = null;
          console.error(error);
          notify("Gagal upload file", "error");
        });
    },

    getFieldValue(field, newData, oldData) {
      // For rowvalidating: safely handle insert (no oldData) and update
      return newData[field] !== undefined
        ? newData[field]
        : oldData && oldData[field] !== undefined
        ? oldData[field]
        : undefined;
    },
    onRowValidating(e) {
      // const newData = e.newData;

      console.log("debug onRowValidating newData", e);

      // e.errorText = "";
      // if (!newData.tgl_awal) {
      //   e.errorText = e.errorText + "Tgl Awal Penilaian harus diisi.";
      //   e.isValid = false;
      //   return;
      // }

      const tglAwal = this.getFieldValue("tgl_awal", e.newData, e.oldData);
      if (!tglAwal) {
        e.errorText += "Tgl Awal Penilaian harus diisi. ";
        e.isValid = false;
        return;
      }

      if (
        this.formEditors["tgl_akhir"].option("value") === undefined ||
        this.formEditors["tgl_akhir"].option("value") == null
      ) {
        e.errorText += "Tgl Akhir Penilaian harus diisi. ";
        e.isValid = false;
        return;
      }

      // if (!newData.tgl_dibuat) {
      //   e.errorText = e.errorText + "Tgl Dibuat harus diisi.";
      //   e.isValid = false;
      //   return;
      // }

      const tglDibuat = this.getFieldValue("tgl_dibuat", e.newData, e.oldData);
      if (!tglDibuat) {
        e.errorText += "Tgl Dibuat harus diisi.";
        e.isValid = false;
        return;
      }

      if (
        this.formEditors["pegawais_nama"].option("value") === undefined ||
        this.formEditors["pegawais_nama"].option("value") == null
      ) {
        e.errorText += "Pegawai yang dinilai harus diisi. ";
        e.isValid = false;
        return;
      }

      /**
       * * VALIDATING PENIALAIAN ini hanya akan terjadi di event oninserting,
       * * devextreme tidak mengirimkan data penilaian di newData pada eventonupdating sehingga validation
       *  *penilaian di updating harus di onUpdating, tidak bisa dihandle oleh rowValidating      */
      const penilaian = this.penilaianDataSource._items || [];
      const invalidAngka = penilaian.some(
        (item) => !item.angka || item.angka <= 0,
      );

      if (invalidAngka) {
        e.errorText +=
          "Semua nilai pada tabel penilaian harus diisi dan lebih dari 0. ";
        e.isValid = false;
        return;
      }

      e.errorText = "";
      e.isValid = true;
      return;
    },

    async onUpdating(e) {
      e.newData.updated_by_user_id = auth.getUser().id; //diubah jika update or remove
      console.log("debug onupdating", e);

      const tglAkhir = this.formEditors["tgl_akhir"].option("value");
      if (
        (tglAkhir instanceof Date
          ? DateTime.fromJSDate(tglAkhir).toFormat("yyyy-MM-dd")
          : tglAkhir) !== e.oldData.tgl_akhir
      ) {
        //tgl akhir diubah
        e.newData.tgl_akhir =
          tglAkhir instanceof Date
            ? DateTime.fromJSDate(tglAkhir).toFormat("yyyy-MM-dd")
            : tglAkhir;
      } else {
        delete e.newData.tgl_akhir; //jangan dihapus, AWAS LHO YAA
      }
      if (this.selectedPegawaiId !== e.oldData.pegawai_id) {
        e.newData.pegawai_id = this.selectedPegawaiId;
      }
      if (this.selectedPenilaiId !== e.oldData.penilai_id) {
        e.newData.penilai_id = this.selectedPenilaiId;
      }
      if (this.selectedAtasanPenilaiId !== e.oldData.atasan_penilai_id) {
        e.newData.atasan_penilai_id = this.selectedAtasanPenilaiId;
      }

      //DETECT CHANGES FOR PENILAIAN

      const penilaianFields = [
        "kesetiaan",
        "kesetiaan_ket",
        "prestasi_kerja",
        "prestasi_kerja_ket",
        "tanggung_jawab",
        "tanggung_jawab_ket",
        "ketaatan",
        "ketaatan_ket",
        "kejujuran",
        "kejujuran_ket",
        "kerjasama",
        "kerjasama_ket",
        "prakarsa",
        "prakarsa_ket",
        "kepemimpinan",
        "kepemimpinan_ket",
        "jumlah",
        "avg",
      ];

      // Get the current penilaian values from the data source
      const penilaianItems = this.penilaianDataSource._items || [];
      const getPenilaianValue = (field) => {
        if (["jumlah", "avg"].includes(field)) {
          if (field === "jumlah") {
            return penilaianItems.reduce(
              (sum, i) => sum + (Number(i.angka) || 0),
              0,
            );
          }
          if (field === "avg") {
            return penilaianItems.length
              ? penilaianItems.reduce(
                  (sum, i) => sum + (Number(i.angka) || 0),
                  0,
                ) / penilaianItems.length
              : null;
          }
        }
        const [main, ket] = field.split("_ket");
        const item = penilaianItems.find((i) => i.field === (main || field));
        if (!item) return null;
        return ket !== undefined ? item.ket : item.angka;
      };

      penilaianFields.forEach((field) => {
        const newValue = getPenilaianValue(field);
        if (newValue !== e.oldData[field]) {
          e.newData[field] = newValue;
        }
      });

      console.log("debug onupdating", e);
      // e.cancel = true;
    },

    async onInserting(e) {
      console.log("debug oninserting", e);

      e.data.tgl_akhir = this.formEditors["tgl_akhir"].option("value");
      e.data.pegawai_id = this.selectedPegawaiId;
      e.data.penilai_id = this.selectedPenilaiId;
      e.data.atasan_penilai_id = this.selectedAtasanPenilaiId;

      const penilaianItems = this.penilaianDataSource._items || [];
      const getAngka = (field, ket = false) => {
        const item = penilaianItems.find((i) => i.field === field);
        if (!item) return null;
        return ket ? item.ket : item.angka;
      };
      e.data.kesetiaan = getAngka("kesetiaan");
      e.data.kesetiaan_ket = getAngka("kesetiaan", true);
      e.data.prestasi_kerja = getAngka("prestasi_kerja");
      e.data.prestasi_kerja_ket = getAngka("prestasi_kerja", true);
      e.data.tanggung_jawab = getAngka("tanggung_jawab");
      e.data.tanggung_jawab_ket = getAngka("tanggung_jawab", true);
      e.data.ketaatan = getAngka("ketaatan");
      e.data.ketaatan_ket = getAngka("ketaatan", true);
      e.data.kejujuran = getAngka("kejujuran");
      e.data.kejujuran_ket = getAngka("kejujuran", true);
      e.data.kerjasama = getAngka("kerjasama");
      e.data.kerjasama_ket = getAngka("kerjasama", true);
      e.data.prakarsa = getAngka("prakarsa");
      e.data.prakarsa_ket = getAngka("prakarsa", true);
      e.data.kepemimpinan = getAngka("kepemimpinan");
      e.data.kepemimpinan_ket = getAngka("kepemimpinan", true);
      e.data.jumlah = penilaianItems.reduce(
        (sum, i) => sum + (Number(i.angka) || 0),
        0,
      );
      e.data.avg = penilaianItems.length
        ? e.data.jumlah / penilaianItems.length
        : null;

      delete e.data.atasan_penilais_nama;
      delete e.data.pegawais_nik;
      delete e.data.penilais_nama;
      e.data.created_by_user_id = auth.getUser().id; //diubah jika update or remove
      console.log("debug oninserting data", e.data);
    },

    async downloadFile() {
      if (this.fileUrl === null || this.fileUrl === "") {
        notify("File tidak ada", "error");
        return;
      }

      try {
        const response = await api.post(
          `${API_BASE_URL}/arsip/download`,
          { file_path: this.fileUrl },
          {
            responseType: "blob",
            headers: {
              Authorization: api.defaults.headers.common["Authorization"],
            },
          },
        );
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        // Extract file extension from Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        const urlParts = this.fileUrl.split(".");
        const extension =
          urlParts.length > 1 ? urlParts[urlParts.length - 1] : "";
        let filename =
          "Arsip Pegawai - " +
          this.dataSourcePegawai.nama +
          " - " +
          this.fileTitle +
          " - " +
          this.fileTableId +
          "." +
          extension;

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Cleanup
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error(error);
        notify("Dokumen gagal didownload.", "error");
      }

      return;
    },
    handleClickDocument(e, title) {
      if (e.data.file_path !== null) {
        this.fileUrl = e.data.file_path;
        if (title === "File Arsip") {
          title =
            title + " - " + e.data.arsip_kategoris_nama + " - " + e.data.nama;
        }

        this.fileTitle = title;
        this.fileTableId = e.data.id;
        this.downloadFile();
      }
    },

    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
      );
    },
    onFileValueChanged(e, cellInfo) {
      const uploadButton = e.element.querySelector(
        ".dx-fileuploader-upload-button",
      );
      const fileContainer = e.element.querySelector(
        ".dx-fileuploader-files-container",
      );
      if (uploadButton) {
        uploadButton.style.display = "none"; // Hide the upload button
      }
      if (fileContainer) {
        fileContainer.style.display = "block"; // Hide the file container
      }

      if (e.value && e.value[0]) {
        const fileNameTemp = e.value[0].name;
        const fileExtension = fileNameTemp.substring(
          fileNameTemp.lastIndexOf(".") + 1,
        );
        this.file = e.value[0];
        console.log("onFileValueChanged file", this.file);
        var guid = this.uuidv4();
        this.fileName = guid + "." + fileExtension;
        this.filePath = "files/" + this.fileName;
        cellInfo.data.setValue(this.filePath);
      }
    },

    handleAngkaSetCellValue(newData, value) {
      newData.angka = value;
      newData.sebutan = this.commonFunction.formatNumberTerbilang(value);
    },

    handlePopupContentReady(e) {
      // A simple check to reset when the popup closes.
      // This is not foolproof, but works for most cases.
      if (!e.component.option("visible")) {
        this.formEditors = {};
      }
    },

    reloadPenilaianDataSource(setData = false) {
      let items = [];
      if (typeof this.penilaianDataSource.items === "function") {
        items = this.penilaianDataSource.items();
      } else if (Array.isArray(this.penilaianDataSource._items)) {
        items = this.penilaianDataSource._items;
      }

      if (Array.isArray(items) && items.length) {
        items.forEach((item) => {
          // your logic here
          console.log("option 1", item);
          if (setData) {
            item.angka = this.formData[item.field] ?? null;
            item.ket = this.formData[item.field + "_ket"] ?? null;
            item.sebutan = this.commonFunction
              ? this.commonFunction.formatNumberTerbilang(item.angka)
              : null;
          } else {
            item.angka = null;
            item.ket = null;
            item.sebutan = null;
          }
        });
      } else {
        // fallback: load from store (async)
        this.penilaianDataSource
          .store()
          .load()
          .then((loadedItems) => {
            console.log("option 2", loadedItems);
            loadedItems.forEach((item) => {
              // your logic here
              console.log("option 3", item);
              console.log("option 3 setdata", setData);
              if (setData) {
                item.angka = this.formData[item.field] ?? null;
                item.ket = this.formData[item.field + "_ket"] ?? null;
                item.sebutan = this.commonFunction
                  ? this.commonFunction.formatNumberTerbilang(item.angka)
                  : null;
              } else {
                item.angka = null;
                item.ket = null;
                item.sebutan = null;
              }
            });
          });
      }
      this.penilaianDataSource.reload && this.penilaianDataSource.reload();
    },
    customizeFormItem(item) {
      if (item.itemType === "simple") {
        item.editorOptions = {
          ...item.editorOptions,
          onInitialized: async (e) => {
            this.formEditors[item.dataField] = e.component;
            if (this.isInserting) {
              this.formEditors[item.dataField].option("value", null);
            }

            if (item.dataField === "tgl_akhir") {
              console.log("debug formData pegawai_id", this.formData);
              if (this.formEditors["tgl_akhir"].option("value")) {
                //ini adalah updating, jadi pegawai source di reload
                this.reloadPenilaianDataSource(true);
              } else {
                this.reloadPenilaianDataSource();
              }
            }

            if (item.dataField === "pegawais_nama") {
              if (this.isUpdating) {
                console.log("reloadpegawai dari oninitialized");
                const dataDuk = await this.reloadPegawai(
                  this.formEditors["tgl_akhir"].option("value"),
                );
                const pegawaiNamaEditor = this.formEditors["pegawais_nama"];

                pegawaiNamaEditor.option("dataSource", dataDuk);

                pegawaiNamaEditor.option("value", this.formData.pegawai_id);

                const selectedPegawai = dataDuk.find(
                  (p) => p.id === this.formData.pegawai_id,
                );
                this.selectedPegawaiId = selectedPegawai.id;
              }
            }

            console.log("debug penilaianDataSource", this.penilaianDataSource);
          },
        };
      }

      if (item.dataField === "tgl_akhir") {
        // Set the onValueChanged handler for the 'tgl_akhir' editor
        item.editorOptions = {
          ...item.editorOptions,
          onValueChanged: async (args) => {
            console.log("debug item", item);

            const tglAwal = this.formEditors["tgl_awal"].option("value");
            if (!tglAwal) {
              notify("Tanggal awal harus diisi terlebih dahulu", "error");
              console.log("debug settonull 1");
              this.formEditors["tgl_akhir"].option("value", null);
              return;
            }
            const pegawaiNamaEditor = this.formEditors["pegawais_nama"];
            if (!args.value) {
              pegawaiNamaEditor.option("dataSource", null);
              pegawaiNamaEditor.option("value", null);
              this.formEditors["pegawais_nik"].option("value", null);
              this.formEditors["pegawais_gol"].option("value", null);
              this.formEditors["pegawais_jabatan"].option("value", null);
              notify("Tanggal akhir harus diisi", "error");
              return;
            }

            if (args.value < tglAwal) {
              console.log("debug settonull 1");
              this.formEditors["tgl_akhir"].option("value", null);
              notify(
                "Tanggal akhir tidak boleh kurang dari tanggal awal",
                "error",
              );
              return;
            }
            console.log("reloadpegawai dari valuechanged");
            const dataDuk = await this.reloadPegawai(args.value);
            pegawaiNamaEditor.option("dataSource", dataDuk);
            console.log(
              "debug selectedPegawaiid pegawai_id",
              this.selectedPegawaiId,
            );
            pegawaiNamaEditor.option("value", this.selectedPegawaiId);
            this.formEditors["tgl_akhir"].option("value", args.value);
            // this.formData.tgl_akhir = args.value;
          },
        };
      }

      if (item.dataField === "pegawais_nama") {
        // Configure the select box
        item.editorOptions = {
          ...item.editorOptions,
          dataSource: [], // Initialize with an empty data source
          valueExpr: "id",
          displayExpr: "nama",
          searchEnabled: true,
          placeholder: "Pilih Pegawai",
          onValueChanged: async (args) => {
            const selectedPegawai = this.pegawaiBasedOnTglSource.find(
              (p) => p.id === args.value,
            );

            if (selectedPegawai) {
              this.selectedPegawaiId = selectedPegawai.id;
              this.formEditors["pegawais_nik"].option(
                "value",
                selectedPegawai.nik,
              );
              this.formEditors["pegawais_gol"].option(
                "value",
                selectedPegawai.golongan_nama,
              );
              this.formEditors["pegawais_jabatan"].option(
                "value",
                selectedPegawai.riwayat_pekerjaans[0].jabatan_print,
              );
              const filters = Object.entries(
                selectedPegawai.riwayat_pekerjaans[0],
              ).map(([key, value]) => [key, "=", value]);

              this.loadingVisible = true;
              this.loadingTitle = "Loading data pejabat penilai...";
              const dataHirarki = await this.hirarkiListStore.getData(filters);
              console.log("debug datahirarkiall", dataHirarki);

              let hirarkiPejabat = null;
              if (
                dataHirarki &&
                Array.isArray(dataHirarki.data) &&
                dataHirarki.data.length > 0 &&
                dataHirarki.data[0].above &&
                Array.isArray(dataHirarki.data[0].above) &&
                dataHirarki.data[0].above.length > 1
              ) {
                hirarkiPejabat = this.getAtasan(dataHirarki.data[0].above[1]);
                if (hirarkiPejabat && hirarkiPejabat.length > 0) {
                  this.selectedPenilaiId = hirarkiPejabat[0].id;
                  this.formEditors["penilais_nama"].option(
                    "value",
                    hirarkiPejabat[0].nama,
                  );
                  this.formEditors["penilais_nik"].option(
                    "value",
                    hirarkiPejabat[0].nik,
                  );
                  this.formEditors["penilais_gol"].option(
                    "value",
                    hirarkiPejabat[0].golongan_nama,
                  );
                  this.formEditors["penilais_jabatan"].option(
                    "value",
                    hirarkiPejabat[0].riwayat_pekerjaans[0].jabatan_print,
                  );
                } else {
                  this.selectedPenilaiId = null;
                  this.formEditors["penilais_nama"].option("value", null);
                  this.formEditors["penilais_nik"].option("value", null);
                  this.formEditors["penilais_gol"].option("value", null);
                  this.formEditors["penilais_jabatan"].option("value", null);
                  notify("Data pejabat penilai tidak ditemukan", "error");
                }
              } else {
                this.selectedPenilaiId = null;
                this.formEditors["penilais_nama"].option("value", null);
                this.formEditors["penilais_nik"].option("value", null);
                this.formEditors["penilais_gol"].option("value", null);
                this.formEditors["penilais_jabatan"].option("value", null);
                notify("Data pejabat penilai tidak ditemukan", "error");
              }

              let hirarkiPejabatAtasan = null;
              if (
                dataHirarki &&
                Array.isArray(dataHirarki.data) &&
                dataHirarki.data.length > 0 &&
                dataHirarki.data[0].above &&
                Array.isArray(dataHirarki.data[0].above) &&
                dataHirarki.data[0].above.length > 2
              ) {
                hirarkiPejabatAtasan = this.getAtasan(
                  dataHirarki.data[0].above[2],
                );
                if (hirarkiPejabatAtasan && hirarkiPejabatAtasan.length > 0) {
                  this.selectedAtasanPenilaiId = hirarkiPejabatAtasan[0].id;
                  this.formEditors["atasan_penilais_nama"].option(
                    "value",
                    hirarkiPejabatAtasan[0].nama,
                  );
                  this.formEditors["atasan_penilais_nik"].option(
                    "value",
                    hirarkiPejabatAtasan[0].nik,
                  );
                  this.formEditors["atasan_penilais_gol"].option(
                    "value",
                    hirarkiPejabatAtasan[0].golongan_nama,
                  );
                  this.formEditors["atasan_penilais_jabatan"].option(
                    "value",
                    hirarkiPejabatAtasan[0].riwayat_pekerjaans[0].jabatan_print,
                  );
                } else {
                  this.selectedAtasanPenilaiId = null;
                  this.formEditors["atasan_penilais_nama"].option(
                    "value",
                    null,
                  );
                  this.formEditors["atasan_penilais_nik"].option("value", null);
                  this.formEditors["atasan_penilais_gol"].option("value", null);
                  this.formEditors["atasan_penilais_jabatan"].option(
                    "value",
                    null,
                  );
                  notify(
                    "Data atasan pejabat penilai tidak ditemukan",
                    "error",
                  );
                }
              } else {
                this.selectedAtasanPenilaiId = null;
                this.formEditors["atasan_penilais_nama"].option("value", null);
                this.formEditors["atasan_penilais_nik"].option("value", null);
                this.formEditors["atasan_penilais_gol"].option("value", null);
                this.formEditors["atasan_penilais_jabatan"].option(
                  "value",
                  null,
                );
                notify("Data atasan pejabat penilai tidak ditemukan", "error");
              }

              this.loadingVisible = false;
            }
          },
        };
      }
    },

    getAtasan(hirarki) {
      const matchFields = [
        "jabatan_id",
        "bagian_id",
        "bidang_id",
        "cabang_id",
        "seksi_id",
        "sub_bagian_id",
        "sub_bidang_id",
        "unit_id",
      ];
      const filteredPegawai = this.pegawaiBasedOnTglSource.filter((pegawai) => {
        const riwayat = pegawai.riwayat_pekerjaans?.[0];
        // console.log("debug riwayat", riwayat);
        if (!riwayat) return false;

        // Check all fields
        return matchFields.every((field) => {
          // For jabatan_id, match with child_jabatan_id from hirarki
          if (field === "jabatan_id") {
            return riwayat.jabatan_id === hirarki.child_jabatan_id;
          }
          // For the rest, match directly
          return riwayat[field] === hirarki[field];
        });
      });

      return filteredPegawai;
    },

    async reloadPegawai(tgl) {
      console.log("debug reloadPegawai tgl", tgl);
      this.loadingVisible = true;
      this.loadingTitle = "Loading data pegawai dan jabatan";
      try {
        const dataDuk = await this.dukListStore.getData([
          ["tgl", "=", tgl],
          ["capeg_tetap", "=", false],
          ["include_direksi", "=", true],
        ]);

        this.pegawaiBasedOnTglSource = [...dataDuk.data];
        if (this.$refs.formInstance && this.$refs.formInstance.instance) {
          this.$refs.formInstance.instance.repaint();
        }
        console.log("debug pegawaiBasedOnTglSource", dataDuk.data);
        this.loadingVisible = false;
        return dataDuk.data;
      } catch (error) {
        console.error("Error fetching dataDuk:", error);
        this.loadingVisible = false;
        notify("Error fetching data pegawai " + error, "error");
      }
    },
    onInitNewRow() {
      this.isInserting = true;
      this.isUpdating = false;
      this.formData = this.initialFormData;
      console.log("initialFormData", this.initialFormData, this.formData);
      this.selectedPegawaiId = null;
      this.selectedAtasanPenilaiId = null;
      this.selectedPenilaiId = null;
    },

    onEditingStart(e) {
      console.log("oneditingstart", e);
      this.isUpdating = true;
      this.isInserting = false;
      this.formData = e.data;
    },

    allowUpdating() {
      if (this.can("pegawai-update")) return true; //adalah admin dan masuk status request payroll
      return false;
    },
    allowAdding() {
      if (this.can("pegawai-create")) return true; //adalah admin dan masuk status request payroll
      return false;
    },
    allowDeleting() {
      if (this.can("pegawai-del")) return true; //adalah admin dan masuk status request payroll
      return false;
    },

    diklatFilteredDataBasedOnMonth(diklats) {
      const year = new Date(diklats[0].tgl).getFullYear();
      const months = Array.from(
        { length: 12 },
        (_, index) => `${year}-${String(index + 1).padStart(2, "0")}`,
      );

      const res = months
        .map((month) => ({
          month,
          ...this.getDiklatFiltered(month, diklats),
        }))
        .filter((data) => data.totalPegawais > 0);

      return res;
    },
    getDiklatFiltered(month, diklats) {
      const diklatPerMonth = _.filter(diklats, (item) =>
        _.startsWith(item.tgl, month),
      );
      const totalPegawais = _.sumBy(
        diklatPerMonth,
        (item) => item.diklat_pegawais.length,
      );
      return {
        totalPegawais,
        diklatPerMonth,
      };
    },

    addBulanCondition(filterValue) {
      if (!Array.isArray(filterValue)) return filterValue;

      // Check if filterValue is a simple condition (not nested)
      if (filterValue.length === 3 && filterValue[0] === "bulan") {
        // Get end of month date

        // Convert to nested structure and modify the second date
        if (filterValue[1] === "between") return filterValue;
        return [
          ["bulan", ">=", filterValue[2]], // Existing bulan condition
          "and",
          [
            "bulan",
            "<=",
            this.commonFunction.endOfMonthDate(filterValue[2], true),
          ], // Modified to end of month
        ];
      }

      // If filterValue is already an array of conditions, find the first 'bulan'
      const bulanConditionIndex = filterValue.findIndex(
        (item) => Array.isArray(item) && item[0] === "bulan",
      );

      if (bulanConditionIndex !== -1) {
        // Extract the existing "bulan" condition
        const bulanCondition = [...filterValue[bulanConditionIndex]];
        (bulanCondition[2] = this.commonFunction.endOfMonthDate(
          bulanCondition[2],
          true,
        )),
          // Insert the new "bulan" condition right after the first "bulan"
          filterValue.splice(bulanConditionIndex + 1, 0, "and", bulanCondition);
      }

      return filterValue;
    },

    displayPenyesuaian(e) {
      if (e.data.status_penyesuaian) return "Penyesuaian";
      return "";
    },
    setPrintAdaFile(e) {
      if (_.isEmpty(e)) return false;
      else return true;
    },

    hilangFilter() {
      // this.absenStore.onMuatButtonClick();
      this.buttonFilterPintasanVisible = false;
    },
    onContextMenuPreparing(e) {
      if (e.target == "content") {
        e.element.id = e.row.data.pegawai_id;

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];
        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          onItemClick: () => {
            e.itemData = "Detail Pegawai";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Lihat Absensi",
          icon: "event",
          onItemClick: () => {
            e.itemData = "Absensi";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Riwayat Gaji",
          icon: "money",
          onItemClick: () => {
            e.itemData = "Riwayat Gaji";
            this.onItemClick(e);
          },
        });
      }
    },
    onItemClick(e) {
      let pegawaiId = e.element.id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["absen_bulans_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },
    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    refreshDatagrid(gridRef) {
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Absen");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Diklat.xlsx",
          );
        });
      });
      e.cancel = true;
    },

    printTahun(diklats) {
      if (diklats.length > 0) {
        return DateTime.fromFormat(diklats[0].tgl, "yyyy-M-dd").year;
      }
    },

    formatNumber(value) {
      // if (value) {
      //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      // }
      // return value;
      if (value !== null && value !== undefined) {
        // Convert the value to a string and remove the decimal part (".00")
        const stringValue = value.toString().split(".")[0];

        // Add thousands separator
        return stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },

    printBulanNama(tgl) {
      let date = DateTime.fromFormat(tgl, "yyyy-M-dd", { locale: "id" });
      if (!date.isValid) {
        date = DateTime.fromFormat(tgl, "yyyy-M", { locale: "id" });
      }
      if (date.isValid) {
        return date.setLocale("id").toFormat("MMMM");
      } else {
        return "";
      }
    },

    wbAoa(worksheet, text, cell) {
      XLSX.utils.sheet_add_aoa(worksheet, [[text]], {
        origin: cell,
      });
    },

    isDateFormatYMD(dateString) {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // Regular expression for Y-m-d format
      return dateRegex.test(dateString);
    },

    convertTglIndonesia(inputDate) {
      if (!inputDate) return "";
      if (!this.isDateFormatYMD(inputDate)) return "";
      const parsedDate = DateTime.fromISO(inputDate);

      // Format the date in the desired Indonesian format
      const formattedDate = parsedDate.setLocale("id").toLocaleString({
        day: "numeric",
        month: "long",
        year: "numeric",
      });

      return formattedDate;
    },
  },
};
</script>
